
namespace Gamification.Gamification {
    export class AssetEsperienzeColumns {
        static columnsKey = 'Gamification.AssetEsperienze';
    }
}